import {
  CC_OVERVIEW_ATTACHED_CLOSING_BAND_PHOTO_HEIGHT,
  CC_OVERVIEW_ATTACHED_CLOSING_BAND_PHOTO_SRC,
  CC_OVERVIEW_ATTACHED_CLOSING_BAND_PHOTO_WIDTH,
} from "@/lib/cc-footer-layout";

export {
  CC_ANTIQUE_HERO_IMAGE,
  CC_ANTIQUE_HERO_IMAGE_AVIF,
  CC_ANTIQUE_HERO_IMAGE_JPG,
  CC_ANTIQUE_HERO_IMAGE_WEBP,
} from "@/components/layout/CcAntiqueHeroPicture";

export {
  CC_OVERVIEW_ATTACHED_CLOSING_BAND_PHOTO_HEIGHT,
  CC_OVERVIEW_ATTACHED_CLOSING_BAND_PHOTO_SRC,
  CC_OVERVIEW_ATTACHED_CLOSING_BAND_PHOTO_WIDTH,
} from "@/lib/cc-footer-layout";

type CcClosingAtmosphereVariant =
  | "home-band"
  | "overview-closing-band"
  | "footer"
  | "attached-footer";

type CcClosingAtmosphereProps = {
  variant: CcClosingAtmosphereVariant;
};

type CcClosingBrandGlowProps = {
  className?: string;
};

/** Brand teal radial wash shared with FAQ closing band (`cc-closing-atmosphere__glow`). */
export function CcClosingBrandGlow({
  className = "cc-closing-brand-glow",
}: CcClosingBrandGlowProps) {
  return <span className={className} aria-hidden="true" />;
}

function CcClosingAtmosphereMedia({ variant }: CcClosingAtmosphereProps) {
  const overview = variant === "overview-closing-band";
  const name = overview ? "odysseus" : "antique";
  const sizes = "100vw";
  const srcSet = (format: string) => [480, 768, 1024].map(width => `/assets/imgs/closing-optimized/${name}-${width}.${format} ${width}w`).join(", ");
  return (
    <picture className="cc-closing-atmosphere__picture">
      <source type="image/avif" srcSet={srcSet("avif")} sizes={sizes} />
      <source type="image/webp" srcSet={srcSet("webp")} sizes={sizes} />
      <img className="cc-closing-atmosphere__img"
        src={overview ? CC_OVERVIEW_ATTACHED_CLOSING_BAND_PHOTO_SRC : "/assets/imgs/contact/antique-hero.jpg"}
        alt="" width={CC_OVERVIEW_ATTACHED_CLOSING_BAND_PHOTO_WIDTH}
        height={overview ? CC_OVERVIEW_ATTACHED_CLOSING_BAND_PHOTO_HEIGHT : 576}
        loading="lazy" decoding="async" fetchPriority="low" />
    </picture>
  );
}

export function CcClosingAtmosphere({ variant }: CcClosingAtmosphereProps) {
  return (
    <div
      className={`cc-closing-atmosphere cc-closing-atmosphere--${variant}`}
      aria-hidden="true"
    >
      <div className="cc-closing-atmosphere__media">
        <CcClosingAtmosphereMedia variant={variant} />
      </div>
      <CcClosingBrandGlow className="cc-closing-atmosphere__glow" />
      <span className="cc-closing-atmosphere__vignette" />
      {variant === "home-band" || variant === "overview-closing-band" ? (
        <>
          <span className="cc-closing-atmosphere__bottom-fade" />
          <span className="cc-closing-atmosphere__bottom-slip" />
        </>
      ) : null}
      {variant === "attached-footer" ? (
        <>
          <span className="cc-closing-atmosphere__top-fade" />
          <span className="cc-closing-atmosphere__top-slip" />
        </>
      ) : null}
    </div>
  );
}
